import {
  GET_ACTIONS,
  GET_ACTIONS_FAIL,
  GET_ACTIONS_SUCCESS,
  ADD_NEW_ACTION,
  ADD_ACTION_SUCCESS,
  ADD_ACTION_FAIL,
  UPDATE_ACTION,
  UPDATE_ACTION_SUCCESS,
  UPDATE_ACTION_FAIL,
  DELETE_ACTION,
  DELETE_ACTION_SUCCESS,
  DELETE_ACTION_FAIL,
  
} from "./actionTypes";

export const getActions = () => ({
  type: GET_ACTIONS,
})

export const getActionsSuccess = actions => ({
  type: GET_ACTIONS_SUCCESS,
  payload: actions,
})

export const getActionsFail = error => ({
  type: GET_ACTIONS_FAIL,
  payload: error,
})

export const addNewAction = data => ({
  type: ADD_NEW_ACTION,
  payload: data,
})

export const addActionSuccess = action => ({
  type: ADD_ACTION_SUCCESS,
  payload: action,
})

export const addActionFail = error => ({
  type: ADD_ACTION_FAIL,
  payload: error,
})

export const updateAction = action => ({
  type: UPDATE_ACTION,
  payload: action,
})

export const updateActionSuccess = action => ({
  type: UPDATE_ACTION_SUCCESS,
  payload: action,
})

export const updateActionFail = error => ({
  type: UPDATE_ACTION_FAIL,
  payload: error,
})

export const deleteAction = data => ({
  type: DELETE_ACTION,
  payload: data,
})

export const deleteActionSuccess = data => ({
  type: DELETE_ACTION_SUCCESS,
  payload: data,
})

export const deleteActionFail = error => ({
  type: DELETE_ACTION_FAIL,
  payload: error,
})

